<template>
  <div>
    <div
      v-if="isOpen && isActive && infoBar.content"
      :class="['info-bar', `bg-${color}`]"
    >
      <div class="container-fluid">
        <div class="row">
          <div class="col px-5">
            <cms-renderer
              class="hint-text"
              :markdown="infoBar.content"
            />
            <span
              class="close-btn"
              @click="closeHint"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import 'index';
</style>

<script>
import InfoBarQuery from '~/domains/application/__gql__/queries/infoBar.gql'

const CmsRenderer = () => import('~/components/DX-CMSRenderer')

export default {
  name: 'InfoBar',
  components: {
    CmsRenderer,
  },
  data() {
    return {
      isOpen: true,
      infoBar: {
        content: '',
      },
      environment: process.env.DEXTRA_ENV,
    }
  },
  computed: {
    isActive() {
      if (!this.infoBar) return false
      const { startDate, endDate } = this.infoBar
      const today = new Date().getTime()
      const hasStarted = today > new Date(startDate).getTime()
      const hasNotEnded = endDate ? today < new Date(endDate).getTime() : true
      return startDate && hasStarted && hasNotEnded
    },
    color() {
      return this.infoBar.color ? this.infoBar.color.toLowerCase() : 'black'
    },
  },
  methods: {
    closeHint() {
      this.isOpen = !this.isOpen
    },
  },
  apollo: {
    infoBar: {
      client: 'cms',
      query: InfoBarQuery,
      variables() {
        return {
          stati:
            this.environment === 'production' || this.environment === 'stage'
              ? ['PUBLISHED']
              : ['PUBLISHED', 'DRAFT'],
        }
      },
      update(data) {
        if (data && data.infoBars) {
          return data.infoBars[0]
        }
        return { content: '' }
      },
    },
  },
}
</script>
